import React, { useContext, useEffect, useState } from 'react';
import { MDBAlert, MDBBtn, MDBCol, MDBLightbox, MDBLightboxItem, MDBRow, MDBSpinner } from 'mdb-react-ui-kit';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import PaginationComponent from '../reusables/PaginationComponent';
import { UserProfileContext } from '../context/UserProfileProvider';

export default function View() {
  const { type } = useParams();
  const { tokenLoaded } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState([]);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertColor, setAlertColor] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (tokenLoaded) {
      const fetchData = async () => {
        setIsLoading(true); // Set loading state to true before fetching data
        try {
          const endpoint = `${baseUrl}/imgs/type/${type}?page=${currentPage}&size=${pageSize}`;
          const response = await axios.get(endpoint, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
          });

          if (response.status === 200) {
            if (Array.isArray(response.data)) {
              setImages(response.data);
            } else {
              console.error('Response data is not an array:', response.data);
            }
          } else {
            console.error(`Error: ${response.status}`);
          } 
        } catch (err) {
          console.error(err);
        } finally {
          setIsLoading(false); // Set loading state to false after fetching data
        }
      };

      fetchData();
    }
  }, [baseUrl, tokenLoaded, type, currentPage, pageSize]);

  const deleteImage = async (id) => {
    const url = `${baseUrl}/imgs/forever/${id}`;
    try {
      const response = await axios.delete(url, {
        withCredentials: true,
      });
      if (response.status === 200) {
        setAlertColor("success");
        setShowAlert(true);
        setAlertMessage('Image deleted successfully');
        const updatedImages = images.filter(image => image.id !== id);
        setImages(updatedImages);
      } else {
        console.error('Failed to delete the image');
      }
    } catch (error) {
      console.error('An error occurred while deleting the image:', error);
    }
  };

  return (
    <>
      <MDBAlert
        open={showAlert}
        color={alertColor}
        position="top-right"
        autohide
        delay={5000}
        appendToBody
        onClose={() => setShowAlert(false)}
      >
        {alertMessage}
        <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#3b5998' }} onClick={() => setShowAlert(false)}>
          <i className="fas fa-check-circle me-3"></i>
        </MDBBtn>
      </MDBAlert>

      {isLoading ? (
        <div className='d-flex m-5 justify-content-center'>
          <MDBSpinner style={{ width: '3rem', height: '3rem' }} color='primary'>
            <span className='visually-hidden'>Loading...</span>
          </MDBSpinner>
        </div>
      ) : (
        <MDBRow className='text-center justify-content-center ms-2 me-2 mt-2'>
          {images?.map(image => (
            <MDBCol lg='2' key={image.id}>
              <MDBLightbox>
                <MDBLightboxItem
                  src={image.thumbnail}
                  fullscreenSrc={image.url} 
                  className='w-100 mb-2 mb-md-4 rounded-6 img-thumbnail'
                />
              </MDBLightbox>
              <MDBBtn onClick={() => deleteImage(image.id)} color='danger'>Delete</MDBBtn>
            </MDBCol>
          ))}
        </MDBRow>
      )}
      <PaginationComponent totalPages={3} onPageChange={handlePageChange} />
    </>
  );
}
